import React, { FC, useState } from "react";
import { PricingLocationSelect } from "../PricingLocationSelect/PricingLocationSelect";
import { TreatmentPricingSummary } from "../PriceList/TreatmentPricingSummary";
import { PricingLocationWithSummaries } from "../../Blocks/ServicePricing/PricingLocationWithSummaries.csharp";
import { ServicePricingParams } from "../../Blocks/ServicePricing/ServicePricingParams.csharp";
import { ServicePricingSummary } from "../../Partials/PricingHighlight/ServicePricingSummary.csharp";

export const ServicePricing: FC<ServicePricingParams> = ({
  pricingLocations,
  defaultLocationId,
  loadExpanded,
  hideEveningWeekendPrice,
  hideLinkToSeeAllPrices,
  hideLocationSelect,
  hideNameAndAccordion,
  selectLocationLabel,
  priceListLabel,
}) => {
  const [selectedLocation, setSelectedLocation] = useState<
    PricingLocationWithSummaries | undefined
  >(pricingLocations.find((l) => l.location.id === defaultLocationId));
  const renderListItem = (location: PricingLocationWithSummaries) => (
    <button
      className="btn fw-normal p-0 btn-link"
      onClick={() => setSelectedLocation(location)}
    >
      {location.location.name}
    </button>
  );

  const renderService = (summary: ServicePricingSummary) => (
    <TreatmentPricingSummary
      {...summary}
      hideHeading={hideNameAndAccordion}
      showWeekendEveningPrices={!hideEveningWeekendPrice}
    />
  );

  return (
    <>
      {!hideLocationSelect && (
        <PricingLocationSelect
          availableLocations={pricingLocations}
          renderListItem={renderListItem}
          currentLocationName={selectedLocation?.location.name ?? ""}
          selectLocationsLabel={selectLocationLabel ?? "Se pris for"}
        />
      )}

      {hideNameAndAccordion
        ? selectedLocation?.summaries.map((summary) => (
            <div className="details mt-1 theme-inherit-light" key={summary.id}>
              {renderService(summary)}
            </div>
          ))
        : selectedLocation?.summaries.map((summary) => (
            <details
              className="details mt-1 theme-inherit-light"
              key={summary.id}
              open={loadExpanded}
            >
              {renderService(summary)}
            </details>
          ))}

      {selectedLocation?.location.priceListUrl && !hideLinkToSeeAllPrices && (
        <div className="row mt-1">
          <p className="read-more">
            <a href={selectedLocation.location.priceListUrl}>
              {priceListLabel ?? "Se alle priser"}
            </a>
          </p>
        </div>
      )}
    </>
  );
};
